import { registerBlockType } from '@wordpress/blocks'
import { __ } from '@wordpress/i18n'
// import { boolean, select, text } from '@storybook/addon-knobs'
import { useState } from '@wordpress/element'
import { compose, withInstanceId } from '@wordpress/compose'
import {
	useBlockProps,
	InnerBlocks,
	RichText,
	InspectorControls,
	__experimentalBlock as Block
} from '@wordpress/block-editor'
import {
	Button,
	FormToggle,
	__experimentalInputControl as InputControl
} from '@wordpress/components'
import { PanelBody, RangeControl, SelectControl } from '@wordpress/components'
import { Component } from '@wordpress/element'
import { HEADER } from './helpers/block-templates'
import { useSelect, select } from '@wordpress/data'
import { generateUID } from './helpers/misc'
import { withState } from '@wordpress/compose'

// const BaseHtml = ({setAttributes, attributes, instanceId}) => {
// }
// const CombinedComponent = compose(withInstanceId)(BaseHtml)

registerBlockType('wp-bootblock/accordion-collapsible', {
	apiVersion: 2,
	title: __('Accordion item – Bootblock', 'wp-bootblock'),
	description: __('A Bootstrap accordion collapsible.', 'wp-bootblock'),
	keywords: [],
	parent: ['wp-bootblock/accordion'],
	icon: 'images-alt',
	category: 'media',
	attributes: {
		content: {
			type: 'array',
			source: 'children',
			selector: 'span'
		},
		uid: {
			type: 'string'
		},
		isOpen: {
			type: 'boolean'
		},
		parentClientId: {
			type: 'string'
		}
	},
	example: {
		attributes: {
			content: 'Hello World',
			isOpen: false
		}
	},
	edit: withState({
		checked: true
	})(({checked, ...props}) => {
		const parentClientId = select('core/block-editor').getBlockHierarchyRootClientId(props.clientId)

		const onChangeContent = (newContent) => {
			props.setAttributes({content: newContent})
		}
		const onChangeOpen = () => {
			props.setAttributes({isOpen: !props.attributes.isOpen})
		}

		if (!props.attributes.uid)
			props.attributes.uid = generateUID()

		const blockProps = useBlockProps({className: 'accordion-item'})
		return (
			<>
				<InspectorControls>
					<PanelBody title={__('Settings', 'wp-bootblock')}>
						<FormToggle
							checked={props.attributes.isOpen}
							onChange={onChangeOpen}
						/> {__('Open initially?', 'wp-bootblock')}
					</PanelBody>
				</InspectorControls>

				<div {...blockProps}>

					<h2 className="accordion-header" id="headingOne">
						<button className={`accordion-button ${props.attributes.isOpen ? '' : 'collapsed'}`}
										type="button"
										data-bs-toggle="collapse"
										data-bs-target={`#collapse-${props.attributes.uid}`}
										aria-expanded={props.attributes.isOpen}
										aria-controls={`collapse-${props.attributes.uid}`}>
							<RichText
								className="my-0"
								tagName="span"
								onChange={onChangeContent}
								value={props.attributes.content}
							/>
						</button>
					</h2>

					<div id={'collapse-' + props.attributes.uid}
							 className={`accordion-collapse collapse ${props.attributes.isOpen ? 'show' : ''}`}
							 aria-labelledby="headingOne"
							 data-bs-parent={'#accordionId-' + parentClientId}>
						<div className="accordion-body inner-container">
							<InnerBlocks/>
						</div>
					</div>

				</div>
			</>
		)
	}),
	save: (props) => {
		const blockProps = useBlockProps.save({className: 'accordion-item'})
		return (
			<div {...blockProps}>

				<h2 className="accordion-header" id="headingOne">
					<button className={`accordion-button ${props.attributes.isOpen ? '' : 'collapsed'}`}
									type="button"
									data-bs-toggle="collapse"
									data-bs-target={`#collapse-${props.attributes.uid}`}
									aria-expanded={props.attributes.isOpen}
									aria-controls={`collapse-${props.attributes.uid}`}>
						<RichText.Content tagName="span" value={props.attributes.content}/>
					</button>
				</h2>

				<div id={`collapse-${props.attributes.uid}`}
						 className={`accordion-collapse collapse ${props.attributes.isOpen ? 'show' : ''}`}
						 aria-labelledby="headingOne"
						 data-bs-parent={`#accordionId-${props.parentClientId}`}>
					<div className="accordion-body inner-container">
						<InnerBlocks.Content/>
					</div>
				</div>

			</div>
		)
	}
})
